import type { PreOrderPaymentKind, ResolvedPreOrderPayment } from './types';

export const PAYMENT_INFO_ERROR = '获取支付信息失败，请重试';

export const UPGRADE_PAYMENT_FIELDS = ['alipayJumpSchema', 'orderNo', 'subscriptionId'] as const;

export const PAYMENT_CREDENTIAL_VALIDATORS: Record<
  PreOrderPaymentKind, (payment: ResolvedPreOrderPayment) => boolean
> = {
  order: ({ innerOrderId }) => Boolean(innerOrderId),
  subscribe: ({ innerOrderId, signNo }) => Boolean(innerOrderId || signNo),
  'ai-sign': ({ signNo }) => Boolean(signNo),
  rights: () => true
};
